<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chisteinbergwagner0007#pref">Preface</a></p>
<p class="toc"><a class="xref" href="#/chisteinbergwagner0008#intro"><span class="sm">INTRODUCTION</span>  Wagnerian Songlines</a></p>
<p class="toc"><a class="xref" href="#/chisteinbergwagner0009#ch01"><span class="sm">ONE</span>  History and the Stage</a></p>
<p class="toc"><a class="xref" href="#/chisteinbergwagner0010#ch02"><span class="sm">TWO</span>  Siegmund’s Death</a></p>
<p class="toc"><a class="xref" href="#/chisteinbergwagner0011#ch03"><span class="sm">THREE</span>  Bad Education</a></p>
<p class="toc"><a class="xref" href="#/chisteinbergwagner0012#ch04"><span class="sm">FOUR</span>  <i>Les passions humaines</i></a></p>
<p class="toc"><a class="xref" href="#/chisteinbergwagner0013#aft"><span class="sm">AFTERWORD</span>  On Purity, Danger, and the Postsecular Moment</a></p>
<p class="tocbmf"><a class="xref" href="#/chisteinbergwagner0014#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chisteinbergwagner0015#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chisteinbergwagner0016#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/chisteinbergwagner0017#gallery">Gallery</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-steinberg-wagner-0006.vue?31a197d3